import { Link } from "react-router-dom";
import { newsItems } from "@/mocks/news";

export default function NewsList() {
  const [featured, ...rest] = newsItems;

  return (
    <section className="w-full px-4 md:px-6 mt-14">
      <div className="flex items-end justify-between gap-4">
        <div>
          <h2 className="text-xl font-bold text-foreground-950 font-heading md:text-2xl">
            最新影视资讯
          </h2>
          <p className="mt-1 text-sm text-foreground-500">
            及时掌握行业动态与热剧热片第一手消息
          </p>
        </div>
        <Link
          to="/category/资讯"
          className="flex shrink-0 items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors cursor-pointer"
        >
          更多资讯
          <i className="ri-arrow-right-s-line"></i>
        </Link>
      </div>

      <div className="mt-6 grid grid-cols-1 gap-6 lg:grid-cols-2">
        <Link
          to={`/detail/${featured.id}`}
          className="group block cursor-pointer overflow-hidden rounded-lg bg-background-100 ring-1 ring-background-200 animate-fade-up"
        >
          <div className="relative w-full aspect-[16/9] overflow-hidden">
            <img
              src={featured.cover}
              alt={featured.title}
              title={`${featured.title} 影视资讯`}
              className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
            />
            <span className="absolute left-3 top-3 rounded-md bg-accent-500 px-2 py-0.5 text-xs font-semibold text-foreground-950">
              {featured.tag}
            </span>
          </div>
          <div className="p-4 md:p-5">
            <h3 className="text-lg font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors line-clamp-2">
              {featured.title}
            </h3>
            <p className="mt-2 text-sm leading-relaxed text-foreground-500 line-clamp-2">
              {featured.summary}
            </p>
            <div className="mt-3 flex items-center gap-3 text-xs text-foreground-400">
              <span className="flex items-center gap-1">
                <i className="ri-calendar-line"></i>
                {featured.date}
              </span>
              <span className="flex items-center gap-1">
                <i className="ri-price-tag-3-line"></i>
                {featured.source}
              </span>
            </div>
          </div>
        </Link>

        <div className="flex flex-col gap-0 divide-y divide-background-200 rounded-lg bg-background-100 ring-1 ring-background-200 overflow-hidden">
          {rest.slice(0, 6).map((item, index) => (
            <Link
              key={item.id}
              to={`/detail/${item.id}`}
              className="group flex items-center gap-4 p-4 transition-colors hover:bg-background-50 cursor-pointer animate-fade-up"
              style={{ animationDelay: `${index * 60}ms` }}
            >
              <div className="w-24 h-16 shrink-0 overflow-hidden rounded-md md:w-28 md:h-[4.5rem]">
                <img
                  src={item.cover}
                  alt={item.title}
                  title={`${item.title} 资讯`}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="min-w-0 flex-1">
                <h3 className="text-sm font-medium text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2">
                  {item.title}
                </h3>
                <div className="mt-1.5 flex items-center gap-3 text-xs text-foreground-400">
                  <span>{item.date}</span>
                  <span className="hidden sm:inline">{item.source}</span>
                </div>
              </div>
              <span className="hidden shrink-0 items-center gap-1 rounded-md bg-secondary-100 px-2 py-0.5 text-xs text-secondary-900 sm:flex">
                {item.tag}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}